export enum JobStatus {
  submitted = 0,
  progressing = 1,
  canceled = 2,
  error = 3,
  complete = 4,
}
